import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Auth } from '../auth';

@Injectable()
export class IsAuthenticatedGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return new Promise<boolean>((resolve) => {
            if (!Auth.isAuthenticated) {
                // this.router.navigate(['/unauthorized']);
              this.router.navigate(['/login']);
            }
            resolve(Auth.isAuthenticated);
        })
    }
}
